import request from '@/api/http'

const role = {
    getUserMenu (params,callback) {
        return request.post(process.env.BASE_URL+`/role/getUserMenu`, params,callback)
    }
}

export default role
